import React from 'react'
import "./BlueButton.css"
export default function BlueButton(props) {
  
  return (
    <div>
      <button className={props.activeBtn} disabled={props.buttonNotActive} onClick={props.handleClick} >{ props.text }</button>
    </div>
  )
}
// <button className={activeBtn} disabled={buttonNotActive} onClick={nextStep}>OK</button>